import React, { useEffect, useState } from 'react';
import Cs from '../../../services/CommonService';
import { DivRichTextView } from '../../Common/RichTextView';
import { Image } from '../../Common/Image';
import { useCurrentUserHook } from '../../Authentication/useUserHook';
import DigitalContentService from '../../DigitalContent/DigitalContentService';

const WhatsNewTab = ({ memberPortalIds = [] }) => {
  const { currentUser } = useCurrentUserHook();

  const [posts,       setPosts]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [page,        setPage]        = useState(1);
  const [meta,        setMeta]        = useState({});

  useEffect(() => {
    getAll(1);
  }, []);

  const getAll = (pageNum = 1) => {
    setLoading(true);

    const filter = {
      organization_id: currentUser.current_organization_id,
    };
    if (memberPortalIds && memberPortalIds.length > 0) {
      filter.member_portal_ids = memberPortalIds;
    }

    const req = {
      page: pageNum,
      per_page: 10,
      sort_column: 'record_id',
      sort_direction: 'desc',
      content_type: 'whats_new',
      filter,
    };

    DigitalContentService.getAll(req).then((res) => {
      setPosts(res.data.digital_contents || []);
      setMeta(res.data.meta || {});
      setPage(pageNum);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };

  const togglePost = (idx) => {
    setActiveIndex(activeIndex === idx ? null : idx);
  };

  if (loading) {
    return (
      <div className="flex aligncenter justifycenter p-40">
        <i className="fas fa-spinner fa-spin font-24 color-grey"></i>
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div className="bg-white brd-10 p-40 text-center">
        <i className="fas fa-newspaper font-40 lgrey m-b-15 d-block"></i>
        <div className="fw500 font-16 dark-navy m-b-5">No posts yet</div>
        <div className="font-13 lgrey">What's New posts will appear here once published.</div>
      </div>
    );
  }

  return (
    <div>
      {posts.map((post, i) => (
        <WhatsNewCard
          key={post.id}
          post={post}
          index={i}
          isOpen={activeIndex === i}
          onToggle={() => togglePost(i)}
        />
      ))}

      {meta.last_page > 1 && (
        <div className="flex justifycenter aligncenter gap-10 m-t-20">
          <button
            className={`btn-primary brd-5 font-13 fw500 p-8-15 ${page <= 1 ? 'op-40 bg-grey-1 color-black' : 'bg-green1-dark text-white'}`}
            disabled={page <= 1}
            onClick={() => getAll(page - 1)}>
            <i className="fas fa-chevron-left m-r-5"></i> Prev
          </button>
          <span className="font-13 lgrey">Page {page} of {meta.last_page}</span>
          <button
            className={`btn-primary brd-5 font-13 fw500 p-8-15 ${page >= meta.last_page ? 'op-40 bg-grey-1 color-black' : 'bg-green1-dark text-white'}`}
            disabled={page >= meta.last_page}
            onClick={() => getAll(page + 1)}>
            Next <i className="fas fa-chevron-right m-l-5"></i>
          </button>
        </div>
      )}
    </div>
  );
};

const WhatsNewCard = ({ post, index, isOpen, onToggle }) => {
  const { data = {} } = post;

  const portalLabels = post.data_source?.org_types
    ?.map(p => p?.label)
    .filter(Boolean) || [];

  return (
    <div className="bg-white brd-10 shadow-small m-b-10 overflow">
      <div className="flex justspacebetween aligncenter p-15 pointer" onClick={onToggle}>
        <div className="flex aligncenter gap-10 flex-grow">
          <span className="badge-2 white" style={{ background: '#80868b' }}>{index + 1}</span>

          <span className="font-15 fw500 dark-navy flex-grow">{data.heading || '(No heading)'}</span>
        </div>

        <div className="flex aligncenter gap-10 flex-shrink">
          {portalLabels.map((label, li) => (
            <span key={li} className="badge-3 bg-blue-white color-highlight">{label}</span>
          ))}

          <span className="font-12 lgrey ws-nowrap">
            {Cs.formatUpdateDate(post.created_at)}
          </span>

          {data.tags_array && data.tags_array.length > 0 && (
            <div className="flex gap-5">
              {data.tags_array.map((tag, ti) => (
                <span key={ti} className="badge-3 bg-pale-green color-green1-dark">{tag}</span>
              ))}
            </div>
          )}

          <i className={`font-14 color-grey ${isOpen ? 'fas fa-angle-up' : 'fas fa-angle-down'}`} />
        </div>
      </div>

      {isOpen && (
        <div className="p-15 p-t-0 br-top-grey">
          {data.body_text && (
            <div className="m-b-15">
              <DivRichTextView className="pre-line font-13 lh-20" html={data.body_text} />
            </div>
          )}

          {data.image && (
            <div className="text-center m-b-15">
              <Image image={data.image} styleName="img-responsive brd-10" />
            </div>
          )}

          <div className="flex justspacebetween aligncenter m-t-10 font-12 lgrey br-top-grey p-t-10">
            <span>Posted by: <span className="fw500 dark-navy">{post.user_name || '—'}</span></span>
            <span>{Cs.formatUpdateDate(post.updated_at, 'MMM D, YYYY hh:mm a')}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsNewTab;